import { Grid } from '@frontierag/frontier-ui-library';
import type { ReactNode } from 'react';
import ProductType from '../ProductFormFields/ProductType';
import { useField } from 'formik';
import { CROP_PRODUCT_TYPE, CROP_VIRTUAL_PRODUCT_TYPE } from 'appConstants';
import ProductName from '../ProductFormFields/ProductName';
import PackNumber from '../ProductFormFields/PackNumber';
import VirtualPack from '../ProductFormFields/VirtualPack';

export default function ProductForm({ actions }: { actions?: ReactNode | ReactNode[] }) {
  const [{ value: productType }] = useField('productType');
  return (
    <Grid direction="column" container rowSpacing={3} wrap="nowrap">
      <Grid item>
        <ProductType />
      </Grid>
      <Grid item>
        {productType === CROP_PRODUCT_TYPE && <ProductName />}
        {productType === CROP_VIRTUAL_PRODUCT_TYPE && <VirtualPack />}
      </Grid>
      <Grid item>
        <PackNumber />
      </Grid>
      {actions && <Grid item>{actions}</Grid>}
    </Grid>
  );
}
